import api from './axiosConfig';
import { handleApiError } from './errorHandler';

export const recipeAPI = {
    create: async (recipeData) => {
        try {
            const { data } = await api.post('/api/recipes/create/', recipeData);
            return data;
        } catch (error) {
            handleApiError(error, 'Create recipe error:');
        }
    },
    getAll: async (page, pageSize, searchTerm, showDeactivated = false) => {
        try {
            const { data } = await api.get('/api/recipes/', {
                params: { page, pageSize, searchTerm, showDeactivated }
            });
            return data;
        } catch (error) {
            handleApiError(error, 'Get all recipes error:');
        }
    },
    getById: async (id) => {
        try {
            const { data } = await api.get(`/api/recipes/${id}/`);
            return data;
        } catch (error) {
            handleApiError(error, 'Get recipe by id error:');
        }
    },
    update: async (id, recipeData) => {
        try {
            const { data } = await api.put(`/api/recipes/update/${id}/`, recipeData);
            return data;
        } catch (error) {
            handleApiError(error, 'Update recipe error:');
        }
    },
    delete: async (id) => {
        try {
            const { data } = await api.delete(`/api/recipes/delete/${id}/`);
            return data;
        } catch (error) {
            handleApiError(error, 'Delete recipe error:');
        }
    },
    addIngredient: async (recipeId, ingredientData) => {
        try {
            const { data } = await api.post(`/api/recipes/${recipeId}/ingredients/add/`, ingredientData);
            return data;
        } catch (error) {
            handleApiError(error, 'Add ingredient error:');
        }
    },
    updateIngredient: async (recipeId, ingredientId, ingredientData) => {
        try {
            const { data } = await api.put(`/api/recipes/${recipeId}/ingredients/${ingredientId}/update/`, ingredientData);
            return data;
        } catch (error) {
            handleApiError(error, 'Update ingredient error:');
        }
    },
    deleteIngredient: async (recipeId, ingredientId) => {
        try {
            const { data } = await api.delete(`/api/recipes/${recipeId}/ingredients/${ingredientId}/delete/`);
            return data;
        } catch (error) {
            handleApiError(error, 'Delete ingredient error:');
        }
    },
    getIngredientInventory: async (recipeId, ingredientId) => {
        try {
            const { data } = await api.get(`/api/recipes/${recipeId}/ingredients/${ingredientId}/available-inventory/`);
            return data;
        } catch (error) {
            handleApiError(error, 'Get ingredient inventory error:');
        }
    },
    getMaxOutput: async (recipeId) => {
        const { data } = await api.get(`/api/recipes/${recipeId}/max-output/`);
        return data;
    }
};
